import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LoaderImage from '../../../assets/images/loader.gif';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    textAlign: 'center',
  },
}));

/**
 * Component to display the Loader
 *
 * @param {Object} props
 */
const Loader = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img src={LoaderImage} alt='Loading' />
    </div>
  );
};

export default Loader;
